import { Box, Stack, useMediaQuery, useTheme } from "@mui/material"
import { usePathname } from "next/navigation"
import { FC, useEffect } from "react"

import { StandBookingSelection } from "src/components/services/account/overview/StandBookingSelection"
import { create } from "src/helpers/bem"
import { getPath, getPaths } from "src/helpers/paths"
import { useLocale } from "src/states/locale"
import { SharedPageProps } from "src/types/SharedPageProps"

import { AccountNavigation } from "./AccountNavigation"
import styles from "./AccountOverview.module.scss"
import { SubHeader } from "./SubHeader"

const bem = create(styles, "AccountOverview")

export const AccountOverview: FC<SharedPageProps> = ({
  messages,
  children,
}) => {
  const locale = useLocale()
  const pathname = usePathname()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xl"))
  const accountPaths = getPaths("account")

  useEffect(() => {}, [locale])

  return (
    <Stack
      className={bem("AccountOverview")}
      direction={"column"}
      spacing={8.125}
    >
      <SubHeader
        accountArea
        homeButton={accountPaths.some((p) => p === pathname)}
        additionals={
          <>
            {isMobile && <AccountNavigation />}
            {!accountPaths.some((p) => p === pathname) && (
              <StandBookingSelection
                messages={messages}
                showAdminOnly={pathname === getPath(locale, "bookings")}
              />
            )}
          </>
        }
      />
      <Stack className={bem("contentWrapper")} direction={"row"} gap={1}>
        {!isMobile && <AccountNavigation />}
        <Box className={bem("content")}>{children}</Box>
      </Stack>
    </Stack>
  )
}
